import { render, staticRenderFns } from "./AddAccountModal.vue?vue&type=template&id=b0906512&scoped=true&"
import script from "./AddAccountModal.vue?vue&type=script&lang=js&"
export * from "./AddAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./AddAccountModal.vue?vue&type=style&index=0&id=b0906512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0906512",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0906512')) {
      api.createRecord('b0906512', component.options)
    } else {
      api.reload('b0906512', component.options)
    }
    module.hot.accept("./AddAccountModal.vue?vue&type=template&id=b0906512&scoped=true&", function () {
      api.rerender('b0906512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/layout/sidebarComponents/AddAccountModal.vue"
export default component.exports